import { Expose, Type } from "class-transformer";

export class CreateTravelTaskDto {
  @Expose()
  origin: string;

  @Expose()
  destiny: string;

  @Expose()
  worksheetHasVehicleId?: string;

  @Expose()
  @Type(() => Number)
  km?: number;
}
